<div mat-dialog-content>
	<p>
		Êtes-vous sûr de vouloir {{texteQuestion}} pour votre client : {{clientString}}?
	</p>
	<p>
		Après confirmation, les commandes {{texteSuppression}} seront misent à jour et les données modifiées seront
		enregistrées.
	</p>
</div>
<div mat-dialog-actions>
	<button mat-raised-button (click)="closeDialog()" color="white">Annuler</button>
	<button mat-raised-button color="primary" (click)="confirm()">Confirmer</button>
</div>